/** 学生端入口（/login）与学习库的准入：需包含 `student`（可与 super_admin 并存；各门户用独立 token）。 */
export function canUseStudentPortal(roles: string[] | undefined): boolean {
  const r = roles ?? [];
  return r.includes("student");
}
